export default __webpack_public_path__ + "static/media/starter-pack-1.9a3d68a6.webp";